import React, { useEffect, useRef, useState } from 'react';
import { Layout, Globe, ShieldCheck, Award, Cpu } from 'lucide-react';


const Milestones = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const milestones = [
    { number: 90, suffix: '+', label: 'Projects', desc: 'Enterprise Solutions', icon: <Layout strokeWidth={1} /> },
    { number: 90, suffix: '+', label: 'Clients', desc: 'Global Partnerships', icon: <Globe strokeWidth={1} /> },
    { number: 95, suffix: '%', label: 'Satisfaction', desc: 'Client Happiness', icon: <ShieldCheck strokeWidth={1} /> },
    { number: 15, suffix: '+', label: 'Experience', desc: 'Years of Mastery', icon: <Award strokeWidth={1} /> },
    { number: 150, suffix: '+', label: 'APIs', desc: 'Cloud Integrations', icon: <Cpu strokeWidth={1} /> },
  ];

  // Mouse Spotlight Logic
  const handleMouseMove = (e) => {
    const cards = document.getElementsByClassName("ms-card");
    for (const card of cards) {
      const rect = card.getBoundingClientRect(),
        x = e.clientX - rect.left,
        y = e.clientY - rect.top;

      card.style.setProperty("--mouse-x", `${x}px`);
      card.style.setProperty("--mouse-y", `${y}px`);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="ms-container" ref={sectionRef} onMouseMove={handleMouseMove}>
      <div className="ms-inner">
        
        {/* Corporate Header */}
        <div className="ms-header" data-aos="fade-up">
          <div className="ms-accent-line"></div>
          <div className="ms-text-group">
            <h2 className="ms-title">
              Our Global
              <span className="ms-gradient-text"> Impact</span>
            </h2>
            <span className="ms-tagline">DRIVING INNOVATION WITH PRECISION.</span>
          </div>
        </div>

        {/* Grid Area */}
        <div className="ms-grid">
          {milestones.map((item, index) => (
            <div 
              key={index} 
              className={`ms-card ${isVisible ? 'ms-fade-in' : ''}`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              {/* The Spotlight Background */}
              <div className="ms-card-spotlight"></div>

              <div className="ms-card-content">
                <div className="ms-icon-wrap">{item.icon}</div>
                
                <div className="ms-number-wrap">
                  <Counter target={item.number} isVisible={isVisible} />
                  <span className="ms-suffix">{item.suffix}</span>
                </div>
                
                <h3 className="ms-label">{item.label}</h3>
                <p className="ms-desc">{item.desc}</p>
              </div>

              {/* Hover Line */}
              <div className="ms-hover-line"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Counter = ({ target, isVisible }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const duration = 2000;
      const increment = Math.ceil(target / (duration / 16));
      const timer = setInterval(() => {
        start += increment;
        if (start >= target) { setCount(target); clearInterval(timer); }
        else { setCount(start); }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isVisible, target]);
  return <>{count}</>;
};

export default Milestones;